import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';
import { useNotification } from '../../../../contexts/NotificationContext';

/**
 * Feedback service hook — Add + List.
 */
export const useFeedback = () => {
  const { showNotification } = useNotification();
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/get_all_patients`, { withCredentials: true })
      .then(res => setPatients(Array.isArray(res.data) ? res.data : []))
      .catch(() => showNotification('error', 'Failed to load patient list.'))
      .finally(() => setLoading(false));
  }, [showNotification]);

  const submitFeedback = async (payload) =>
    axios.post(`${API_BASE_URL}/add_feedback`, payload, { withCredentials: true });

  return { patients, loading, submitFeedback };
};

/**
 * Feedback List service hook — fetch all feedbacks.
 */
export const useFeedbackList = () => {
  const { showNotification } = useNotification();
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/get_feedbacks`, { withCredentials: true })
      .then(res => setFeedbacks(
        Array.isArray(res.data.feedbacks) ? res.data.feedbacks :
        Array.isArray(res.data.data) ? res.data.data :
        Array.isArray(res.data) ? res.data : []
      ))
      .catch(() => showNotification('error', 'Failed to fetch feedback records.'))
      .finally(() => setLoading(false));
  }, [showNotification]);

  const deleteFeedback = async (feedback_id) => {
    const res = await axios.delete(`${API_BASE_URL}/delete_feedback/${feedback_id}`, { withCredentials: true });
    if (res.status === 200) setFeedbacks(prev => prev.filter(f => (f.id || f.feedback_id) !== feedback_id));
  };

  return { feedbacks, loading, deleteFeedback };
};
